import React from "react";
import ForStudentMenu from "../components/ForStudentMenu";
import Withdrawal from "../components/Withdrawal";

const StudentWithdrawal = () => {
       return (
              <div className="App-full-row-container">
                     <div className="left-menu-box-1" style={{fontWeight:"bolder", color:"orange" ,marginTop:"10px", marginBottom:"1px", marginLeft:"30px"}}>
                            <ForStudentMenu />
                     </div>
                     <div className="content-box-1">
                            <Withdrawal />
                     </div>
              </div>
       )
} 

export default StudentWithdrawal;